// extracted by mini-css-extract-plugin
export default {"ets":"U1GxtZxeKClN3UkLB2oC"};